import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage }     from './pages/auth/LoginPage';
import { RegisterPage }  from './pages/auth/RegisterPage';
import { AppLayout }     from './components/layout/AppLayout';
import { DashboardPage } from './pages/dashboard/DashboardPage';

// Página placeholder para rutas aún no implementadas
function ComingSoon({ label }: { label: string }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <span className="text-5xl mb-4">🚧</span>
      <h2 className="text-lg font-bold text-gray-800 mb-1">{label}</h2>
      <p className="text-sm text-gray-400">En construcción — próxima iteración</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── Rutas públicas (sin layout) ── */}
        <Route path="/login"    element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* ── Rutas protegidas (con AppLayout) ── */}
        <Route element={<AppLayout />}>
          <Route path="/dashboard"     element={<DashboardPage />} />
          <Route path="/orders"        element={<ComingSoon label="Mis Órdenes" />} />
          <Route path="/trucks"        element={<ComingSoon label="Mis Camiones" />} />
          <Route path="/services"      element={<ComingSoon label="Mis Servicios" />} />
          <Route path="/messages"      element={<ComingSoon label="Mensajería" />} />
          <Route path="/notifications" element={<ComingSoon label="Notificaciones" />} />
          <Route path="/profile"       element={<ComingSoon label="Perfil" />} />
        </Route>

        {/* Redirect raíz y 404 → login */}
        <Route path="/"  element={<Navigate to="/login"    replace />} />
        <Route path="*"  element={<Navigate to="/dashboard" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
